import { forwardRef } from 'react';
import InfoFillGrayIcon from '@/assets/icons/InfoFillGrayIcon.svg?react';

/**
 * 이용 방법 확인하기 트리거 버튼. 리스트 페이지 타이틀 옆에 배치해
 * DialogTrigger 로 감싸 사용한다 (Monitoring, ProductOptimization 공용).
 */
const TutorialTriggerButton = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
  return (
    <button
      ref={ref}
      type="button"
      {...props}
      className={`flex items-center gap-[2px] rounded-[8px] bg-white px-[10px] py-[6px] ${
        props.className ?? ''
      }`}
    >
      <InfoFillGrayIcon />
      <span className="text-gr-700 Body5M14">이용 방법 확인하기</span>
    </button>
  );
});

TutorialTriggerButton.displayName = 'TutorialTriggerButton';

export default TutorialTriggerButton;
